export const productPath = (p) => `/produit/${typeof p === "string" ? p : p?.id || ""}`;
